import ServicePage from '@/components/ServicePage';

export default function WorkplaceAutomationPage() {
  return (
    <ServicePage
      slug="workplace-automation"
      title="Workplace Automation Services"
      titleAr="خدمات أتمتة مكان العمل"
      description="Automate repetitive tasks, streamline workflows, and boost productivity across your Egyptian business. Custom automation solutions that integrate with your existing tools and eliminate manual work."
      descriptionAr="أتمت المهام المتكررة، وأسهل سير العمل، وعزز الإنتاجية في عملك المصري. حلول أتمتة مخصصة تتكامل مع أدواتك الحالية وتقضي على العمل اليدوي."
      keywords="workplace automation tools, business process automation, task automation software, workflow automation, productivity automation, RPA Egypt"
      heroImage="https://readdy.ai/api/search-image?query=Workplace%20automation%20concept%20visualization%2C%20digital%20workflow%20connecting%20office%20tasks%20and%20processes%2C%20clean%20modern%20interface%20elements%2C%20robotic%20process%20automation%2C%20professional%20business%20photography%2C%20blue%20and%20white%20color%20palette%2C%20technology%20productivity&width=1400&height=600&seq=svc4&orientation=landscape"
      icon="ri-settings-3-line"
      features={[
        {
          title: 'Task Automation',
          titleAr: 'أتمتة المهام',
          description: 'Automate repetitive data entry, file transfers, email responses, and report generation. Python scripts and no-code tools handle the boring work so your team can focus on strategy.',
          descriptionAr: 'أتمت إدخال البيانات المتكرر، ونقل الملفات، واستجابات البريد الإلكتروني، وإنشاء التقارير. تتعامل نصوص Python وأدوات بدون كود مع العمل الممل حتى يتمكن فريقك من التركيز على الاستراتيجية.',
        },
        {
          title: 'Workflow Integration',
          titleAr: 'تكامل سير العمل',
          description: 'Connect your CRM, ERP, accounting software, and communication tools into seamless workflows. Data flows automatically between systems without manual copying.',
          descriptionAr: 'اربط CRM و ERP و برامج المحاسبة وأدوات التواصل في سير عمل سلسة. تتدفق البيانات تلقائياً بين الأنظمة دون نسخ يدوي.',
        },
        {
          title: 'Data Processing Pipelines',
          titleAr: 'خطوط معالجة البيانات',
          description: 'Build automated ETL pipelines that extract data from multiple sources, transform it, and load it into your warehouse or reporting system on schedule.',
          descriptionAr: 'بناء خطوط ETL آليّة تستخرج البيانات من مصادر متعددة، وتحولها، وتحملها في مستودعك أو نظام التقارير حسب الجدول.',
        },
        {
          title: 'Document Automation',
          titleAr: 'أتمتة المستندات',
          description: 'Auto-generate invoices, contracts, reports, and certificates using templates and data from your systems. OCR integration extracts data from scanned documents.',
          descriptionAr: 'توليد الفواتير والعقود والتقارير والشهادات تلقائياً باستخدام قوالب وبيانات من أنظمتك. يستخرج تكامل OCR البيانات من المستندات الممسوحة.',
        },
        {
          title: 'Communication Automation',
          titleAr: 'أتمتة الاتصالات',
          description: 'Automated WhatsApp Business messages, SMS notifications, email sequences, and Slack alerts. Keep customers and teams informed without manual effort.',
          descriptionAr: 'رسائل WhatsApp Business الآلية، وإشعارات SMS، وسلاسل البريد الإلكتروني، وتنبيهات Slack. أبقِ العملاء والفرق على علم دون جهد يدوي.',
        },
        {
          title: 'Smart Reporting Systems',
          titleAr: 'أنظمة التقارير الذكية',
          description: 'Scheduled dashboards and reports that compile data from all your systems and deliver insights to stakeholders automatically. No more manual spreadsheet compilation.',
          descriptionAr: 'لوحات معلومات وتقارير مجدولة تجمع البيانات من جميع أنظمتك وتقدم رؤى للأصحاب المصلحة تلقائياً. لا مزيد من التجميع اليدوي لجداول البيانات.',
        },
      ]}
      benefits={[
        {
          title: 'Save 15-20 Hours Per Week',
          titleAr: 'وفر 15-20 ساعة في الأسبوع',
          description: 'Our automation solutions typically save teams 15-20 hours weekly on manual tasks. That is hundreds of thousands of EGP in annual productivity gains.',
          descriptionAr: 'توفر حلول الأتمتة لدينا عادةً 15-20 ساعة أسبوعياً للفرق على المهام اليدوية. هذا مئات الآلاف من الجنيهات المصرية في مكاسب الإنتاجية السنوية.',
        },
        {
          title: 'Eliminate Human Error',
          titleAr: 'قضاء على الخطأ البشري',
          description: 'Manual data entry has an error rate of 1-4%. Automation reduces this to near zero. Your financial records, inventory, and customer data stay accurate.',
          descriptionAr: 'يحتوي إدخال البيانات اليدوي على معدل خطأ 1-4٪. يقلل الأتمتة هذا إلى ما يقرب من الصفر. تبقى سجلاتك المالية، ومخزونك، وبيانات عملائك دقيقة.',
        },
        {
          title: 'Integrate Everything',
          titleAr: 'تكامل كل شيء',
          description: 'We connect Odoo, SAP, Salesforce, Zoho, QuickBooks, Google Workspace, Microsoft 365, and custom systems. If it has an API, we can automate it.',
          descriptionAr: 'نربط Odoo، و SAP، و Salesforce، و Zoho، و QuickBooks، و Google Workspace، و Microsoft 365، والأنظمة المخصصة. إذا كان لديه API، يمكننا أتمتته.',
        },
        {
          title: 'ROI Within 3-6 Months',
          titleAr: 'العائد على الاستثمار في غضون 3-6 أشهر',
          description: 'Most automation projects pay for themselves within 3-6 months through labor savings alone. The productivity gains compound over time.',
          descriptionAr: 'تدفع معظم مشاريع الأتمتة تكلفتها في غضون 3-6 أشهر من خلال توفير العمالة وحده. تتضاعف مكاسب الإنتاجية مع مرور الوقت.',
        },
      ]}
      faqs={[
        {
          question: 'What tasks can be automated in my business?',
          questionAr: 'ما هي المهام التي يمكن أتمتتها في عملي؟',
          answer: 'Any repetitive, rule-based task can be automated: data entry between systems, report generation, invoice processing, email follow-ups, social media posting, inventory updates, appointment reminders, and more. We audit your workflows and identify the best opportunities.',
          answerAr: 'يمكن أتمتة أي مهمة متكررة وقائمة على القواعد: إدخال البيانات بين الأنظمة، وإنشاء التقارير، ومعالجة الفواتير، ومتابعات البريد الإلكتروني، ونشر وسائل التواصل الاجتماعي، وتحديثات المخزون، وتذكير المواعيد، وأكثر. ندقق سير عملك ونحدد أفضل الفرص.',
        },
        {
          question: 'Do I need to replace my existing software?',
          questionAr: 'هل أحتاج إلى استبدال برمجياتي الحالية؟',
          answer: 'No. We design automation that works with your existing tools. We integrate via APIs, webhooks, and database connections. Your team keeps using the software they know, while the automation handles the integration.',
          answerAr: 'لا. نصمم أتمتة تعمل مع أدواتك الحالية. نتكامل عبر APIs، و webhooks، واتصالات قاعدة البيانات. يواصل فريقك استخدام البرمجيات التي يعرفها، بينما تتعامل الأتمتة مع التكامل.',
        },
        {
          question: 'How do you monitor automated workflows?',
          questionAr: 'كيف تراقبون سير العمل الآلي؟',
          answer: 'All automations include logging, error alerting, and fallback mechanisms. If a step fails, you get notified immediately. We provide dashboards showing success rates, execution times, and error logs.',
          answerAr: 'تتضمن جميع الأتمتات تسجيلاً، وتنبيهات أخطاء، وآليات احتياطية. إذا فشلت خطوة، يتم إخطارك فوراً. نقدم لوحات معلومات تعرض معدلات النجاح، وأوقات التنفيذ، وسجلات الأخطاء.',
        },
      ]}
      relatedServices={[
        { slug: 'custom-development', title: 'Custom Development', titleAr: 'التطوير المخصص', icon: 'ri-code-s-slash-line' },
        { slug: 'cloud-services', title: 'Cloud Services', titleAr: 'الخدمات السحابية', icon: 'ri-cloud-line' },
        { slug: 'performance-optimization', title: 'Performance Optimization', titleAr: 'تحسين الأداء', icon: 'ri-speed-line' },
      ]}
    />
  );
}